import { Badge } from '@/components-new/badge';
import React from 'react';

type MarketBasketPurposeBadgeProps = {
  purpose: string;
};

const MarketBasketPurposeBadge = ({ purpose }: MarketBasketPurposeBadgeProps) => {
  const purposeLabel = (purpose?: string) => {
    if (purpose === 'bid_analysis') return 'Bid Analysis';
    if (purpose === 'market_share') return 'Market Share';
    return purpose ?? '—';
  };

  return (
    <Badge color={purpose === 'bid_analysis' ? 'blue' : 'teal'}>
      {purposeLabel(purpose)}
    </Badge>
    );
  };
export default MarketBasketPurposeBadge;
